import { IHydraConfig } from '@assess/browser/hydra';

export const hydra: IHydraConfig = {
  account: window.APP_CONFIG.ACCOUNT_ID,
  applicationId: window.APP_CONFIG.APP_ID,
  customerAcronym: window.APP_CONFIG.CUSTOMER_ID,
  domain: window.APP_CONFIG.ACCOUNT_ID === 'development' ? 'development.arcadiaanalytics.com' : 'arcadiaanalytics.com',
};
